import { Button, Checkbox, Col, Form, Input, Row, Segmented, Spin } from "antd";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import "../styles/login.css";
import { logData } from "../utils/SystemSpecsHelper";
import Loader from "../components/Loader";
import Icon from "../assets/Icon";
import RegistrationLeftSide from "../components/RegistrationLeftSide";
import {
  getOnBoardingStatusApi,
  getProfileInfoApi,
  loginApi,
} from "../api/common";

let logs = logData();

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const redirect = urlParams.get("redirect");

function Login() {
  const [ip, setIp] = useState();
  const [selectedUserRole, setSelectedUserRole] =
    useState("JOBDRONA_CANDIDATE");
  const [tab, setTab] = useState("JOBDRONA_CANDIDATE");

  const [formData, setFormData] = useState({
    loginEmail: "",
    loginPassword: "",
  });

  const [reChapthaDisable, setReChapthaDisable] = useState(true);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setrEmemberMe] = useState(false);

  const formChangeHandler = (event) => {
    setFormData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setIp(data.ip);
        localStorage.setItem("ipAddress", data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };
    fetchIpAddress();
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const getOnboardStatus = async (userIdentifier, userRole, token) => {
    setLoading(true);
    const url = `${getOnBoardingStatusApi}?userIdentifier=${
      userIdentifier ? userIdentifier : null
    }&userRole=${userRole}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      setLoading(false);

      if (result.data === "ONBOARDING_REQUIRED") {
        window.location.href = "/candidateOnboarding";
      } else if (result.data === "COMPLETED") {
        if (redirect) {
          window.location.href = redirect;
        } else {
          window.location.href = "/";
        }
      } else {
        setMessage(
          <div style={{ textAlign: "center", color: "red" }}>
            There is problem with your account. Please contact{" "}
            <a href="mailto:support@hireplusplus.com">
              support@hireplusplus.com
            </a>
          </div>,
        );
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getProfileData = async (userIdentifier, userRole, token, data) => {
    const url = `${getProfileInfoApi}?userIdentifier=${userIdentifier}`;
    // setLoading(true);

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      // setResponse(result);
      // setLoading(false);

      localStorage.setItem("userData", JSON.stringify(result.data));
      if (data?.userPasswordRequired) {
        window.location.href = "/password-required";
        return;
      }

      if (
        userRole === "JOBDRONA_ORG_ADMIN" ||
        userRole === "JOBDRONA_B2B_CANDIDATE"
      ) {
        if (redirect) {
          window.location.href = redirect;
        } else {
          window.location.href = "/";
        }
      } else {
        getOnboardStatus(userIdentifier, userRole, token);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callLoginApi = async (values) => {
    // Convert email and password to Base64
    let emailSmall = values?.loginEmail?.toLowerCase();

    const encodedEmail = btoa(emailSmall);
    const encodedPassword = btoa(values.loginPassword);

    const url = loginApi;
    const data = {
      email: encodedEmail,
      password: encodedPassword,
      sessionInfo: {
        deviceId: `${logs.osType} / ${logs.browserType}`,
        ipAddress: ip,
        dateTimeInfo: logs.dateTimeInfo,
        loginValidationResult: "string",
        deviceInfo: {},
      },
      // userRole: selectedUserRole,
    };

    setLoading(true);
    localStorage.setItem("rememberMe", rememberMe);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      setLoading(false);
      localStorage.setItem("userEmail", values.loginEmail);
      if (result.resultStatusInfo.resultCode === "Unauthorized") {
        setMessage(
          <div style={{ textAlign: "center", color: "red" }}>
            {result.resultStatusInfo.message}
          </div>,
        );
      } else if (
        result.resultStatusInfo.resultCode.toLowerCase() === "success"
      ) {
        getProfileData(
          result.data.userIdentifier,
          result.data.userRole,
          result.data.accessToken,
          result?.data,
        );

        localStorage.setItem("userDetails", JSON.stringify(result.data));
      } else if (result.resultStatusInfo.resultCode === "ACCOUNT_INACTIVE") {
        window.location.href = "./checkMail";
      } else if (result.resultStatusInfo.resultCode === "ACCOUNT_LOCKED") {
        window.location.href = "./userLock";
      } else {
        setMessage(
          <div style={{ textAlign: "center", color: "red" }}>
            Username or password is incorrect
          </div>,
        );
      }
    } catch (error) {
      setLoading(false);
      setMessage(
        <div style={{ textAlign: "center", color: "red" }}>
          Something is wrong
        </div>,
      );
      console.log(error);
    }
  };

  const onFinish = (values) => {
    callLoginApi(values);
  };
  function onCaptchaChange(value) {
    setReChapthaDisable(false);
    document.querySelector("#hirePPRecaptcha iframe").style.border = "none";
  }
  function onExpiredChange(value) {
    document.querySelector("#hirePPRecaptcha iframe").style.border =
      "2px solid red";
    setReChapthaDisable(true);
  }

  const handleRememberMe = (e) => {
    setrEmemberMe(e.target.checked);
  };
  return (
    <>
      {loading && <Loader />}
      <div className=" main-div">
        <Row className="login-container  min-h-[90vh]">
          <Col className="left-div-cont sm:block hidden">
            <RegistrationLeftSide selectedUserRole={selectedUserRole} />
          </Col>
          <div className=" p-0 m-0 h-0  w-full  res-logo">
            <Icon type="hire-logo" width={80} height={60} />
          </div>
          <Col className="login-form">
            <div className=" sm:hidden flex items-center justify-start ">
              <div className="px-8 py-4 flex items-center gap-x-2">
                <Icon type="jobdrona-logo" width={35} />
                <span className="font-semibold leading-10 text-[1.2rem] text-orangish">
                  JobDrona
                </span>
              </div>
            </div>
            <div className="m-auto login-div max-w-[500px]">
              <p className="new-login-text p-0 m-0">Login</p>
              <p className="new-login-sub-text p-0 m-0 mb-[0.8rem]">
                Welcome back! Please enter your details.
              </p>
              {/* <Segmented
                options={[
                  {
                    label: "Candidate",
                    value: "JOBDRONA_CANDIDATE",
                  },
                  // {
                  //   label: "Employer",
                  //   value: "EMPLOYER",
                  // },
                ]}
                onChange={(value) => {
                  setTab(value);
                  setSelectedUserRole(value);
                }}
                className="w-full mb-2"
                block
                size="large"
              /> */}
              <Form
                name="basic"
                //   initialValues={{ remember: true }}
                onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                layout="vertical"
                className="mt-4"
              >
                <Form.Item
                  label={
                    <span className="text-[#344054] font-medium">Email</span>
                  }
                  // className="new-login-form-text"
                  rules={[
                    { required: true, message: "Please enter your email!" },
                  ]}
                  name="loginEmail"
                >
                  <Input
                    name="loginEmail"
                    className="rounded-3"
                    size="large"
                    onChange={formChangeHandler}
                  />
                </Form.Item>

                <Form.Item
                  name="loginPassword"
                  label={
                    <span className="text-[#344054] font-medium">Password</span>
                  }
                  className="p-0 m-0 mb-[0.3rem]"
                  // className="new-login-form-text"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                  ]}
                >
                  <Input.Password
                    name="loginPassword"
                    className="rounded-3"
                    size="large"
                    onChange={formChangeHandler}
                  />
                </Form.Item>

                <Form.Item
                  name="remember"
                  valuePropName="checked"
                  // valuePropName={rememberMe}
                  className="p-0 m-0 mb-2"
                >
                  <p className=" p-0 m-0  flex justify-between items-end ">
                    <span className="p-0 m-0 text-[#344054] font-medium">
                      <Checkbox
                        checked={rememberMe}
                        onChange={handleRememberMe}
                      >
                        Remember me
                      </Checkbox>
                    </span>
                    <span className="p-0 m-0   text-[#206DC5] font-semibold">
                      {/* <a href="/forgotPassword">Forgot password</a> */}
                      <Link to="/forgotPassword" className="">
                        Forgot password
                      </Link>
                    </span>
                  </p>
                </Form.Item>
                <div
                  className="w-100 m-auto flex justify-center mb-2"
                  // type={config.type}
                  // style={{
                  //   width: props.loginFlag && "85%",
                  //   fontSize: props.loginFlag && "1.1rem",
                  //   margin: "auto",
                  // }}
                >
                  <ReCAPTCHA
                    id="hirePPRecaptcha"
                    sitekey="6LctnlkpAAAAAIG2BRLu70wFnmmIlPi6S-ieqaBp"
                    onChange={onCaptchaChange}
                    onExpired={onExpiredChange}
                  />
                </div>

                <Form.Item className="p-0 m-0 mb-3">
                  <button
                    className="w-full btn-orange py-2 px-3 cursor-pointer"
                    size="large"
                    htmlType="submit"
                    disabled={reChapthaDisable}
                  >
                    Login
                  </button>
                  <p className="p-0 m-0 mt-1">{message && message}</p>
                </Form.Item>
              </Form>

              <p className="text-center new-login-sub-text mb-2">
                Don't have an account?{" "}
                <Link className="text-[#206DC5] font-semibold" to="/signup">
                  Sign up
                </Link>
              </p>
            </div>
          </Col>
        </Row>
        <div className="copyright-mobile text-[0.82rem] ml-2 flex items-center text-greyish">
          © {new Date().getFullYear()} Copyright JobDrona, India. All rights
          reserved.
        </div>
      </div>
    </>
  );
}

export default Login;
